import {LegacyRef, MutableRefObject, useEffect, useRef, useState} from "react";
import {IUserRegistrationRequest} from "../../services/medicationmanagement/userRegistration/models/UserRegistrationRequest";
import {logger} from "../common/logger";


type FormState = {[key:string]:string|null};
export type ErrorState = {[key in keyof FormState]:boolean};
export type Validator =  (val:string|null)=>boolean;
type ValidationState = {[key:string]:Validator};




const validate = (state:FormState,validations:ValidationState, field:string):ErrorState=>{
        let val = state[field];
        let validation = validations[field];
        if (validation){
            return {
                [field]:!validation(val)
            };
        }
        return {};
}

const isValid = (errors:ErrorState)=>{
    return !Object.keys(errors).some(x=>errors[x]);
}

export function useForm<T>(formRef:MutableRefObject<LegacyRef<HTMLFormElement>|undefined>){
    let [model,setModel] = useState<FormState>({});
    let [errors,setError] = useState<ErrorState>({});
    let modelRef = useRef<FormState>({});
    let validationRef = useRef<ValidationState>({});
    
    const register =(field:Extract<keyof T, string>,value:string|null,validator?:Validator|'Required')=>{

        modelRef.current={
            ...modelRef.current,
            [field]: value
        };

        if (validator) {
            let newValidator = typeof validator==='function'?validator:(val:string|null)=>{
                return !!val;
            };
                
            validationRef.current={
                ...validationRef.current,
                [field]:newValidator
            };
        }
        return {value:model[field],name:field, onChange:handleChange(field as string)};
    };
    const handleChange = (field:string)=>(evnt:any)=>{
        
        let val = 'format' in evnt?evnt.format('yyyy-MM-DD'):evnt?.target?.value
        if (field) {
            let newModel = {
                ...model,
                [field]:val
            };   
            setModel(newModel);
            setError(
                {
                    ...errors,
                    ...validate(newModel,validationRef.current,field)
                }
            );
        }
    }

    const handleSubmit = (callBack:(data:T)=>void)=>{
        let error = Object.keys(model).reduce((acc,x)=>{
            return {
                ...acc,
                ...validate(model,validationRef.current,x)
            };
        },errors);
        setError(error);
        logger.log('Errors',error);
        logger.log('State',model);
        if (isValid(error)) {
            callBack(model as any);
        }else{
            if (formRef && formRef.current) {
                let formElement:any = formRef.current;
                let keyToFocus = Object.keys(formElement)
                .filter(x=>!isNaN(x as any))
                .find(x=>{
                    let elem = formElement[parseInt(x)];
                    let attribute=elem.getAttribute('name');
                    return attribute && error[attribute];
                });
                if (keyToFocus) {
                    let elementToFocus = formElement[parseInt(keyToFocus)];
                    elementToFocus.focus();    
                }
                

                
            }
        }
    }

    useEffect(()=>{
        setModel(modelRef.current);
    },[]);
    
    return {
        model,
        errors,
        register,
        handleSubmit
    };
}


export type UserRegistrationForm = Omit<IUserRegistrationRequest, "phoneNumber"> & {
    phoneLocal:string;
    phoneArea:string;
};

export const errorMessages = new Map<string,string>([['Required','This field is required']]);